import { Component, ContentChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { I18N } from 'ess-plugin-base';

@Component({
    selector: 'smart-list',
    templateUrl: './list.html',
    styleUrls: ['./list.scss']
})
export class SmartList implements OnInit, OnChanges {

    @Input('data')
    data: any[];

    filtered: any[] = [];

    phrase: string;

    selected: any;

    @ContentChild(TemplateRef, {static: false}) 
    template: TemplateRef<any>;

    @Output('select')
    onSelect: EventEmitter<any> = new EventEmitter<any>();

    @Output('search')
    onSearch: EventEmitter<any> = new EventEmitter<any>();
    // onSearch = (phrase: string): Promise<any[]> => { 
    //     return new Promise<any[]>((resolve) => { 
    //         resolve([]);
    //     })
    // }

    constructor(public i18n: I18N) {}

    ngOnInit() {
        this.load();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data) {
            this.load();
        }
    }

    load() {
        // this.filtered = [].concat(this.data);

        if (this.onSearch.observers.length) {
            this.onSearch.emit(this.phrase);
            // this.onSearch(this.phrase)
            // .then(result => this.data = result );
        } else {
            if (!this.data || !this.data.length) {
                this.filtered = [];
            } else if (!this.phrase || !this.phrase.length) {
                this.filtered = (Array.isArray(this.data))? [].concat(this.data) : [];
            } else {
                this.filtered = this.data.filter(item => {
                    return this.match(this.phrase, item)
                })
            }
            // if (this.phrase) this.phrase.length
        }
    }

    match(phrase: string, item: any): boolean {
        if (item && item.startsWith && item.includes) {
            return (phrase.length < 3)? item.startsWith(this.phrase) : item.includes(this.phrase);
        }
        else
        for(let key of Object.keys(item)) {
            if (item && item[key] && item[key].startsWith && item[key].includes) {
                if ((phrase.length < 3)? item[key].startsWith(this.phrase) : item[key].includes(this.phrase)) return true;                            
            }
        }
        return false;
    }

    doSelect(item: any) {
        this.selected = item;
        if (this.onSelect) {
            this.onSelect.emit(item);
        }
    }
}